"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPluralContainer = void 0;
var plural_rules_1 = __importDefault(require("intl-pluralrules/plural-rules"));
var isPluralContainer = function (variableToCheck) {
    return typeof variableToCheck === "object" && variableToCheck.hasOwnProperty("one") && variableToCheck.hasOwnProperty("other");
};
exports.isPluralContainer = isPluralContainer;
var BaseLocalizationService = /** @class */ (function () {
    function BaseLocalizationService(provider) {
        this.provider = provider;
    }
    BaseLocalizationService.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var locs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.provider.get(this.locale)];
                    case 1:
                        locs = (_a.sent());
                        this.setLocales(locs);
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseLocalizationService.prototype.setLocales = function (locs) {
        this.locs = locs;
    };
    /**
     * Get intherited objects by dot annotation
     * @param code
     */
    BaseLocalizationService.prototype.getValueByCode = function (code) {
        var scope = this.locs;
        var codeParts = code.split(".");
        for (var _i = 0, codeParts_1 = codeParts; _i < codeParts_1.length; _i++) {
            var key = codeParts_1[_i];
            if (typeof scope === "object" && scope.hasOwnProperty(key)) {
                scope = scope[key];
            }
            else {
                console.warn("Problem with key ".concat(code, " missing ").concat(key, "."));
                scope = code;
                break;
            }
        }
        return scope;
    };
    BaseLocalizationService.prototype.translate = function (code, size) {
        var value = this.getValueByCode(code);
        if (typeof value === "string") {
            return value;
        }
        else if (typeof value === "number") {
            return value.toString();
        }
        else if ((0, exports.isPluralContainer)(value)) {
            var pluralValue = value[this.pluralForm(size)];
            if (pluralValue) {
                return pluralValue;
            }
            else if (size === 1) {
                return value.one;
            }
            else {
                return value.other;
            }
        }
        else {
            console.warn("There is problem with translation of ".concat(code, ". ").concat(value, " has to be string, number, or ILocalizationPluralsContainer"));
            return code;
        }
    };
    BaseLocalizationService.prototype.pluralForm = function (size) {
        if (size === void 0) { size = 1; }
        return new plural_rules_1.default(this.locale).select(size);
    };
    /**
     * Return date in proper format according to localization
     *
     * @param {Date} date
     * @returns {string}
     */
    BaseLocalizationService.prototype.formatDate = function (date, options) {
        if (!date) {
            return "";
        }
        return date.toLocaleDateString(this.locale, options);
    };
    /**
     * Return time in proper format according to localization
     *
     * @param {Date | string} time
     * @returns {string}
     */
    BaseLocalizationService.prototype.formatTime = function (time, options) {
        if (options === void 0) { options = { hour: "2-digit", minute: "2-digit" }; }
        if (!time) {
            return "";
        }
        return time.toLocaleTimeString(this.locale, options);
    };
    /**
     * Return date and time in proper format according to localization
     * @param date
     * @returns {string}
     */
    BaseLocalizationService.prototype.formatDateTime = function (date, options) {
        if (!date) {
            return "";
        }
        return date.toLocaleString(this.locale, options);
    };
    /**
     * Return number in proper format according to localization.
     *
     * @param {number} num
     * @returns {string}
     */
    BaseLocalizationService.prototype.formatNumber = function (num, options) {
        if (Number(num) !== num) {
            return "";
        }
        return num.toLocaleString(this.locale, options);
    };
    return BaseLocalizationService;
}());
exports.default = BaseLocalizationService;
